export const Transitions = {
  all: 'all 0.25s ease',
  allLong: 'all 0.5s ease',
  duration: '0.25s',
  durationLong: '0.5s',
  durationNumeric: 250,
  durationNumericLong: 500,
}
